import { DEFAULT_COVER_IMAGES } from '../config/site'

/**
 * 判断封面图字段是否为空。
 * 涵盖：undefined、null、''、纯空白、以及字符串形式的 'null' / 'NULL'（大小写不敏感）。
 */
export function isEmptyCover (value) {
  if (value === null || value === undefined) return true
  if (typeof value === 'string') {
    const s = value.trim().toLowerCase()
    return s === '' || s === 'null'
  }
  return false
}

/**
 * 解析封面地址：字段为空时使用全局默认值（按 type 取 DEFAULT_COVER_IMAGES），
 * 否则原样返回真实封面。
 * @param {*} cover   原始封面地址
 * @param {'activity'|'investment'|'dynamics'} type  封面类型
 * @returns {string}  最终可用的封面地址（兜底为空串）
 */
export function resolveCover (cover, type) {
  if (!isEmptyCover(cover)) return cover
  return DEFAULT_COVER_IMAGES[type] || ''
}
